<script lang="ts" setup>
/**
 * ユーザー情報 > ニックネーム、プロフィール画像。
 */

import AppConst from "@/modules/const";

interface Props {
	/**
	 * ニックネーム。
	 */
	nickName: string | undefined;
	/**
	 * プロフィール画像。
	 */
	profilePicUrl: string | undefined;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();

const replaceDefaultImage = (e: Event): void => {
	if (!e.target) return;
	e.target.src = AppConst.PROFILE_PIC_DEFAULT_IMAGE;
};
</script>

<template>
	<div class="revico-community-talk-user-nickname-profile-pic">
		<img class="revico-community-talk-user--profile-pic" :src="profilePicUrl" @error="replaceDefaultImage" />
		<div class="revico-community-talk-user--nickname">{{ nickName }}</div>
	</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-user {
		&-nickname-profile-pic {
			display: flex;
			align-items: center;
			margin-bottom: 8px;
		}
		&--profile-pic {
			width: 40px;
			height: 40px;
			margin: 0 8px 0 -4px;
			border-radius: 50%;
			object-fit: cover;
		}
		&--nickname {
			width: 68vw;
			max-width: 400px;
			overflow-wrap: break-word;
		}
	}
}
</style>
